import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";

import DateRangeBar from "ui/DateRangeBar";
import Loading from "ui/Loading";
import PageContent from "ui/PageContent";
import QueryOverviewGraph from "features/Queries/QueryOverviewGraph";

import {
  Dashboard as DashboardType,
  DashboardVariables,
} from "./types/Dashboard";
import CheckUp from "./CheckUp";
import QUERY from "./Query.graphql";
import styles from "./style.module.scss";
import System from "./System";
import TableTreeMap from "./TableTreeMap";

const Dashboard: React.FunctionComponent = () => {
  const { databaseId } = useParams();
  const { error, loading, data } = useQuery<DashboardType, DashboardVariables>(
    QUERY,
    {
      variables: {
        databaseId,
      },
    },
  );
  if (loading || error) {
    return <Loading error={!!error} />;
  }
  const database = data.getDatabaseDetails;
  const server = data.getServerDetails;
  const organizationSlug = server.organization.slug;

  return (
    <PageContent
      title="Dashboard"
      pageControls={<DateRangeBar />}
      windowTitle={`Dashboard: ${database.datname} / ${server.name}`}
      pageCategory="database"
      pageName="show"
    >
      <div className={styles.dashboardColumns}>
        <div className={styles.dashboardMain}>
          <div className={styles.dashboardSection}>
            <h4>Query Runtime</h4>
            <QueryOverviewGraph
              databaseId={databaseId}
              className={styles.queryOverviewGraph}
            />
          </div>
          <div className={styles.dashboardSection}>
            <h4>Tables</h4>
            <TableTreeMap
              organizationSlug={organizationSlug}
              databaseId={databaseId}
            />
          </div>
        </div>
        <div className={styles.dashboardSidebar}>
          <div className={styles.dashboardSection} id="checkup">
            <CheckUp
              organizationSlug={organizationSlug}
              databaseId={databaseId}
            />
          </div>
          <div className={styles.dashboardSection}>
            <System serverId={server.humanId} />
          </div>
        </div>
      </div>
    </PageContent>
  );
};

export default Dashboard;
